import type { SimpleVehicleProps } from '../types/types'

export type VehicleFilters = {
  status?: string | string[]
  contactPerson?: string | string[]
  invoiceGroup?: string | string[]
  vehicleMake?: string | string[]
  vehicleType?: string | string[]
  fuelType?: string | string[]
  consolidateInvoiceCode?: string | string[]
  deviationCodes?: string[]
}

export function filterVehicles(vehicles: SimpleVehicleProps[], filters: VehicleFilters): SimpleVehicleProps[] {
  return vehicles.filter((vehicle) => {
    const matchStatus = !filters.status?.length || filters.status.includes(vehicle.status)

    const matchDriver = !filters.contactPerson?.length || filters.contactPerson.includes(vehicle.driverName)

    const matchInvoice = !filters.invoiceGroup?.length || filters.invoiceGroup.includes(vehicle.invoiceGroup)

    const matchMake = !filters.vehicleMake?.length || filters.vehicleMake.includes(vehicle.make.toUpperCase())

    const matchFuel = !filters.fuelType?.length || filters.fuelType.includes(vehicle.fuel)

    const matchConsolidatedInvoiceCode =
      !filters.consolidateInvoiceCode?.length ||
      filters.consolidateInvoiceCode.includes(vehicle.consolidatedInvoiceCode)

    const matchVehicleType = !filters.vehicleType?.length || filters.vehicleType.includes(vehicle.vehicleType)

    // Merge deviations and warnings for filtering
    const allDeviations = [...(vehicle.deviations || []), ...(vehicle.warnings || [])]
    const deviationCodes = allDeviations.map((d) => d.code)
    const matchDeviation =
      !filters.deviationCodes?.length || filters.deviationCodes.some((code) => deviationCodes.includes(code))

    return (
      matchStatus &&
      matchDriver &&
      matchInvoice &&
      matchMake &&
      matchFuel &&
      matchConsolidatedInvoiceCode &&
      matchVehicleType &&
      matchDeviation
    )
  })
}
